import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M11.062 4.967c.516-.974 1.358-.978 1.876 0l7.124 13.458c.516.974.045 1.771-1.057 1.771H4.995c-1.102 0-1.575-.793-1.057-1.771zm.23 9.74A1.001 1.001 0 0 0 13 14V9a.997.997 0 0 0-1-1 .997.997 0 0 0-1 1v5c0 .265.105.52.293.707zm0 3a1.001 1.001 0 0 0 1.415-1.414.997.997 0 0 0-1.414 0 .997.997 0 0 0 0 1.414z" }, null, -1)
  ]))]))
}
export default { render: render }